module.exports = __webpack_public_path__ + "img/img-vpower.44d07557.png";